import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import Seo from "../lib/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { SEO_CITIES, CITY_SLUGS } from "../lib/seoPages";

export default function Ciudades() {
    return (
        <>
            <Seo
                title="Centros de rehabilitación de drogas por ciudad en Chile"
                description="Encuentra centros de rehabilitación de drogas en las principales ciudades de Chile: Santiago, Viña del Mar, Concepción, Antofagasta, Temuco y más."
                path="/ciudades"
                keywords="centros rehabilitación por ciudad, rehabilitación Santiago, rehabilitación Viña del Mar, rehabilitación Concepción"
            />

            <section className="border-b border-slate-800 bg-slate-950">
                <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
                    <Breadcrumbs
                        items={[
                            { name: "Inicio", path: "/" },
                            { name: "Ciudades" },
                        ]}
                    />
                    <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-cyan-500/30 bg-cyan-500/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-cyan-300">
                        <MapPin className="h-3.5 w-3.5" />
                        Cobertura nacional
                    </div>
                    <h1 className="mt-5 text-3xl font-bold tracking-tight text-slate-50 sm:text-5xl">
                        Centros de rehabilitación por ciudad
                    </h1>
                    <p className="mt-3 max-w-2xl text-slate-400">
                        Explora directorios y contenido editorial dedicado para las
                        principales ciudades de Chile. Compara centros con información
                        verificada en cada localidad.
                    </p>
                </div>
            </section>

            <section className="py-12">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                        {CITY_SLUGS.map((slug) => {
                            const city = SEO_CITIES[slug];
                            return (
                                <Link
                                    key={slug}
                                    to={`/ciudades/${slug}`}
                                    data-testid={`city-card-${slug}`}
                                    className="card-hover group rounded-xl border border-slate-800 bg-slate-900 p-5"
                                >
                                    <div className="flex items-center gap-2 text-cyan-400">
                                        <MapPin className="h-4 w-4" />
                                        <span className="text-xs font-medium uppercase tracking-wider">
                                            {city.isCapital ? "Capital" : "Ciudad"}
                                        </span>
                                    </div>
                                    <h2 className="mt-3 text-lg font-semibold text-slate-50 group-hover:text-cyan-400">
                                        {city.name}
                                    </h2>
                                    <p className="mt-2 text-xs text-slate-400">
                                        Región {city.region}
                                    </p>
                                    {city.population ? (
                                        <p className="mt-1 text-xs text-slate-500">
                                            {city.population}
                                        </p>
                                    ) : null}
                                    <div className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-cyan-400">
                                        Ver ciudad{" "}
                                        <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </section>
        </>
    );
}
